export enum MessageType {
    SMS = 0,
    Email = 1
}
